module.exports = __webpack_public_path__ + "img/no_prize_icon.40dba4e4.png";